import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { Modal, Spinner } from "react-bootstrap";
import {
  BestVendeurApi,
  ListVendeurAll,
} from "../../_App/Redux/Slices/statistique/statistiqueSlice";

export default function ListStatistiqueVendeur({
  societe_id,
  OrganisationList,
  filtreIni,
  t,
  showModal,
  setShowModal,
}: any) {
  const [typeVendeur, setTypeVendeur] = useState("Tout");
  const [nombrefiltre, setNombrfiltre] = useState(10);
  const [filtre, setFiltre] = useState(filtreIni);
  const [loader, setloader] = useState(false);
  const dispatch = useAppDispatch();
  const list = useAppSelector(ListVendeurAll);
  useEffect(()=>{
    if(showModal){
        findVendeurStat('Tout',0)
    }
  },[showModal])
  const findVendeurStat = (type=typeVendeur ,nbr=nombrefiltre) => {
    const data = {
      date_debut: filtre?.date_debut_vendeur,
      date_fin: filtre?.date_fin_vendeur,
      organisation_id: filtre?.Organisation_vendeur,
      societe_id: societe_id,
      type,
      nombre: nbr,
    };

    setloader(true);

    dispatch(BestVendeurApi(data));
  };
  useEffect(()=>{
    if(list) setloader(false)
  },[list])

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      animation={false}
      className="modal-1"
      dialogClassName="modal-70w"
      backdropClassName="modal-backdrop-1"
    >
      <div className="widget widget-card-four ">
        <div className="widget-content">
          <div className="w-header ">
            <div className="row">
              <div className="col-2">{t("Date Debut")}</div>
              <div className="col-2">{t("Date Fin")}</div>
              <div className="col-2">{t("Organisation")}</div>
              <div className="col-3">{t("Type")}</div>
              <div className="col-2"></div>
            </div>
            <div className="row">
              <div className="col-2">
                <input
                  type="date"
                  className="form-control"
                  value={filtre?.date_debut_vendeur}
                  onChange={(e) =>
                    setFiltre((prev: any) => ({
                      ...prev,
                      date_debut_vendeur: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="col-2">
                <input
                  type="date"
                  className="form-control"
                  value={filtre?.date_fin_vendeur}
                  onChange={(e) =>
                    setFiltre((prev: any) => ({
                      ...prev,
                      date_fin_vendeur: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="col-2">
                <select
                  className="form-control"
                  value={filtre?.Organisation_vendeur}
                  onChange={(e) =>
                    setFiltre((prev: any) => ({
                      ...prev,
                      Organisation_vendeur: e.target.value,
                    }))
                  }
                >
                  <option value="tout">Tout les Organisation</option>
                  {OrganisationList?.map((item: any) => (
                    <option key={item._id} value={item._id}>
                      {item?.nom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-3">
                <select
                  className="form-control"
                  value={typeVendeur}
                  onChange={(e) => setTypeVendeur(e.target.value)}
                >
                  <option value="Tout">Tout les Vendeur</option>
                  <option value="Best"> les meilleurs vendeurs</option>
                  <option value="worst"> les plus fainéant</option>
                </select>
              </div>
              {typeVendeur !== "Tout" && (
                <div className="col-1">
                  <input
                    type="number"
                    className="form-control"
                    value={nombrefiltre}
                    onChange={(e) => setNombrfiltre(parseInt(e.target.value))}
                    placeholder={t("nombre de list")}
                  />
                </div>
              )}
              <div className="col-2">
                <i
                  onClick={()=>findVendeurStat()}
                  className="fas fa-search fa-lg"
                ></i>
              </div>
            </div>
          </div>
          <div className="w-body">
            {loader ? (
              <Spinner animation="grow" />
            ) : (
              <table className="table">
                <thead>
                  <th>{t("Vendeur")}</th>
                  <th>{t("Total net a payer")}</th>
                  <th>{t("Nombre des tickets")}</th>
                  <th>{t("Nombre des  piéces")}</th>
                  <th>{t("Moyenne Net panie")}</th>
                </thead>
                <tbody>
                  {list.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>
                        {item?.vendeur === null
                          ? "inconnu"
                          : item?.vendeur?.nom + " " + item?.vendeur?.prenom}
                      </td>
                      <td>{item?.totalNet?.toFixed(3)}</td>
                      <td>{item?.totalOrders}</td>
                      <td>{item?.countArticle}</td>
                      <td>{(item?.totalNet / item?.totalOrders).toFixed(3)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
